import { Button } from "@synthesis/shared-ui";
import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft } from "@synthesis/shared-icons";

type GoBackButtonProps = {
  className?: string;
};

export const GoBackButton = ({ className }: GoBackButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      type="button"
      theme="text"
      size="sm"
      onClick={() => navigate({ to: "/" })}
      className={className}
      leftIcon={<IconArrowLeft className="size-5" />}
    >
      Назад
    </Button>
  );
};
